import React from 'react';

export default ({ color = '#A4A4A4', size = 13 }) => (
  <svg width={size} height={size} viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.5 13C2.91005 13 0 10.0899 0 6.5C0 2.91005 2.91005 0 6.5 0C10.0899 0 13 2.91005 13 6.5C13 10.0899 10.0899 13 6.5 13ZM6.5 5.5809L4.6618 3.74205L3.74205 4.6618L5.5809 6.5L3.74205 8.3382L4.6618 9.25795L6.5 7.4191L8.3382 9.25795L9.25795 8.3382L7.4191 6.5L9.25795 4.6618L8.3382 3.74205L6.5 5.5809Z" fill={color}/>
  </svg>
);
